module.exports = __webpack_public_path__ + "static/media/GradientCovariance.e653f856.ipynb";